import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZoneEditionError() {
      return getState().error;
    },
    isZoneEditionRequestFailure() {
      return getState().request.isFailure;
    },
    isZoneEditionRequestPending() {
      return getState().request.isPending;
    },
    isZoneEditionRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
